import { useEffect, useState } from 'react'
import { MenuComponent } from '../../../../../../../../_metronic/assets/ts/components'
import { initialQueryState } from '../../../../../../../../_metronic/helpers'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { getDivision, getUsersByReportingId, getZone } from '../../../../../master/core/_requests'

const ListFilter = () => {
  const { updateState } = useQueryRequest()
  const [status, setStatus] = useState('');
  const [items_per_page, setMyPage] = useState('100');
  const [divisions, setDivisions] = useState([])
  const [division_id, setDivisionId] = useState('0')
  const [zones, setZones] = useState([])
  const [zone_id, setZoneId] = useState('0')


  useEffect(() => {
    MenuComponent.reinitialization()

    getDivision().then((result) => {
      if (result.error === false) {
        setDivisions(result.data)
      } else {
        setDivisions([])
      }
    })

    getZone().then((result) => {
      if (result.error === false) {
        setZones(result.data)
      }
    })



  }, [])

  return (
    <>
      <div className='d-flex align-items-center position-relative my-1'>
        <select className='form-control form-control-solid fs-7'
          data-kt-select2='true'
          data-placeholder='Select option'
          data-allow-clear='true'
          data-kt-outlets-table-filter='my_page_row'
          data-hide-search='true'
          style={{ appearance: "auto" }}
          onChange={(e) => {

            setMyPage(e.target.value)
            updateState(
              {
                filter: { items_per_page: e.target.value, status, zone_id,  division_id},
                ...initialQueryState,
              }
            )
          }}
          // value={myPage}
        >
          <option value='100'>100</option>
          <option value='10'>10</option>
          <option value='50'>50</option>
          <option value='200'>200</option>
        </select>
      </div>
   
      <div className='d-flex align-items-center position-relative my-1'>
      {/* <span className='mx-2'>Filter: </span> */}
        <select
          className='form-control form-control-solid w-120px  fs-7'
          data-kt-select2='true'
          data-placeholder='Select option'
          data-allow-clear='true'
          data-kt-items-table-filter='status_row'
          data-hide-search='true'
          style={{appearance: "auto"}}
          onChange={(e) => {
            setStatus(e.target.value);
            updateState(
             
            
              {
              filter: { status: e.target.value, zone_id, items_per_page, division_id},
              ...initialQueryState,
            }            
            )
          }}
        >
          <option value="">-Status-</option>
          <option value="A">Active</option>
          <option value="I">Inactive</option>
        </select>
      </div>

      <div className='d-flex align-items-center position-relative my-1'>
        {/* <span className='mx-2'>Filter: </span>  */}
        <select
          className='form-control form-control-solid w-150px  fs-7'
          data-kt-select2='true'
          data-placeholder='Select option'
          data-allow-clear='true'
          data-kt-outlets-table-filter='division_row'
          data-hide-search='true'
          style={{ appearance: "auto" }}
          onChange={(e) => {

            setDivisionId(e.target.value)
            updateState(
              {
                filter: { division_id: e.target.value, items_per_page, status,zone_id },
                ...initialQueryState,
              }
            )
          }}
        // value={divisionId}
        >
          <option value="">-Division-</option>
          {divisions && divisions.map(({ division_name, division_id }) => (
            <option key={division_id} value={division_id}>
              {division_id}-{division_name}
            </option>
          ))}
        </select>
      </div>
      <div className='d-flex align-items-center position-relative my-1'>
        {/* <span className='mx-2'>Filter: </span> */}
        <select
          className='form-control form-control-solid w-150px  fs-7'
          data-kt-select2='true'
          data-placeholder='Select option'
          data-allow-clear='true'
          data-kt-outlets-table-filter='zone_row'
          data-hide-search='true'
          style={{ appearance: "auto" }}
          onChange={(e) => {

            setZoneId(e.target.value)
            updateState(
              {
                filter: { zone_id: e.target.value, items_per_page, status, division_id },
                ...initialQueryState,
              }
            )
          }}
          // value={zoneId}
        >
          <option value="">-Zone-</option>
          {zones && zones.map(({ zone_name, zone_id }) => (
            <option key={zone_id} value={zone_id}>
             {zone_id}-{zone_name}
            </option>
          ))}
        </select>
      </div>
    

    </>
  )
}

export { ListFilter }
